import { Logo } from "@/components/logo"

/**
 * Reserves marketing-nav height while role-dependent chrome is unresolved.
 * Prevents CLS from a late-mounting header without painting the wrong shell.
 */
export function ChromePlaceholder() {
  return (
    <header className="mkt-nav home-wf" aria-busy="true" aria-label="Loading navigation">
      <div className="home-wf-shell mkt-nav-inner">
        <span className="home-wf-brand" aria-hidden>
          <Logo />
        </span>
        <div className="mkt-nav-links pointer-events-none" aria-hidden>
          <span className="inline-block h-3 w-20 animate-pulse rounded bg-foreground/10" />
          <span className="inline-block h-3 w-16 animate-pulse rounded bg-foreground/10" />
          <span className="inline-block h-3 w-14 animate-pulse rounded bg-foreground/10" />
        </div>
        <div className="mkt-nav-actions mkt-nav-actions--desktop pointer-events-none" aria-hidden>
          <span className="inline-block h-8 w-16 animate-pulse rounded bg-foreground/10" />
          <span className="inline-block h-8 w-14 animate-pulse rounded bg-foreground/10" />
        </div>
        <span
          className="mkt-nav-menu pointer-events-none inline-block size-5 animate-pulse rounded bg-foreground/10"
          aria-hidden
        />
      </div>
    </header>
  )
}
